let hljs = require('highlight.js');

let testContent = `/crm/reports/report/view/9/?set_filter=Y&sort_id=3&sort_type=ASC&F_DATE_TYPE=week&F_DATE_FROM=&F_DATE_TO=&F_DATE_DAYS=&filter%5B0%5D%5B0%5D=&filter%5B0%5D%5B1%5D=&save=Y
{"glossary": {"title": "example glossary","GlossDiv": {"title": "S","GlossList": {"GlossEntry": {"ID": "SGML","SortAs": "SGML","GlossTerm": "Standard Generalized Markup Language","Acronym": "SGML","Abbrev": "ISO 8879:1986","GlossDef": {"para": "A meta-markup language, used to create markup languages such as DocBook.","GlossSeeAlso": ["GML", "XML"]},"GlossSee": "markup"}}}    }}`;

let styles = {

    url: {
        reformat: (str) => {
            str = str.trim();
            str = str.replace(/([?&#])/g, '\n\t$1');
            str = decodeURI(str);
            return str;
        },
        format: (str) => {
            str = str.replace(/\s+([?&#])/g, '$1');
            str = str.replace(/=([^=&#]+)/g, (a, b) => '=' + encodeURIComponent(b));
            return str;
        }
    },

    json: {
        reformat: (str) => {
            str = str.trim();

            try {
                str = JSON.stringify(JSON.parse(str), null, "\t");
            } catch (e) {
                str = str.replace(/([\[{])"/g, "$1\n\"");
                str = str.replace(/(["}\]])\s*,\s*(["{\[])/g, "$1,\n$2");
                str = str.replace(/:\s*([{\[])/g, ": \n$1");
                str = str.replace(/(\S)\s*([\]}])/g, "$1\n$2");
                str = str.replace(/([}\]])\s*([}\]])/g, "$1\n$2");

                str = str.replace(/^\s*[\r\n]/gm, '');

                let strs = str.split("\n");
                let level = 1;
                for (let i = 0; i < strs.length; i++) {
                    let a = strs[i].trim();

                    if (/[}\]]/.test(a)) {
                        level--;
                    }

                    strs[i] = a;
                    if (level > 0) {
                        strs[i] = new Array(level).join("\t") + strs[i];
                    }

                    if (/[{\[]/.test(a)) {
                        level++;
                    }
                }
                str = strs.join("\n");
            }

            return str;
        },
        format: (str) => {
            try {
                str = JSON.stringify(JSON.parse(str));
            } catch (e) {
                let strs = str.split("\n");
                for (let i = 0; i < strs.length; i++) {
                    strs[i] = strs[i].trim();
                }
                str = strs.join('');
            }

            return str;
        }
    },

};

hljs.configure({
    tabReplace: '    ',
});

hljs.registerLanguage('url', (a) => {
    return {
        contains: [
            {
                className: 'string',
                begin: /[?&#]/,
                end: "=",
                relevance: 5
            }
        ]
    }
});

$('.js-prettifying-page').each(function () {
    let $this = $(this);

    let $raw = $this.find('.js-prettifying-raw');
    let $code = $this.find('.js-prettifying-code');
    let $result = $this.find('.js-prettifying-result');
    let currentStyle = styles.url;

    copyToCode();
    $this.on('click', '.js-prettify', function () {
        copyToCode($(this));
    });
    $code.on('keyup', copyToResult);

    $this.on('click', '.js-copy', function () {
        $result.select();
        document.execCommand('copy');
    });

    $this.on('click', '.js-test', function() {
        $raw.val(testContent);
    });

    function copyToCode($button = undefined) {
        if ($button) {
            currentStyle = styles[$button.data('type')];
            $code[0].className = $button.data('type');
        }
        $code.html(currentStyle.reformat($raw.val()));
        hljs.highlightBlock($code[0]);
        copyToResult();
    }

    function copyToResult() {
        $result.html(currentStyle.format($code.text()));
    }
});